/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AmsVidMappingResponse } from './AmsVidMappingResponse';
import {
    AmsVidMappingResponseFromJSON,
    AmsVidMappingResponseFromJSONTyped,
    AmsVidMappingResponseToJSON,
    AmsVidMappingResponseToJSONTyped,
} from './AmsVidMappingResponse';

/**
 * 
 * @export
 * @interface AmsParametersResponse
 */
export interface AmsParametersResponse {
    /**
     * 
     * @type {number}
     * @memberof AmsParametersResponse
     */
    sid: number;
    /**
     * 
     * @type {Array<AmsVidMappingResponse>}
     * @memberof AmsParametersResponse
     */
    mappings: Array<AmsVidMappingResponse>;
}

/**
 * Check if a given object implements the AmsParametersResponse interface.
 */
export function instanceOfAmsParametersResponse(value: object): value is AmsParametersResponse {
    if (!('sid' in value) || value['sid'] === undefined) return false;
    if (!('mappings' in value) || value['mappings'] === undefined) return false;
    return true;
}

export function AmsParametersResponseFromJSON(json: any): AmsParametersResponse {
    return AmsParametersResponseFromJSONTyped(json, false);
}

export function AmsParametersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmsParametersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sid': json['sid'],
        'mappings': ((json['mappings'] as Array<any>).map(AmsVidMappingResponseFromJSON)),
    };
}

export function AmsParametersResponseToJSON(json: any): AmsParametersResponse {
    return AmsParametersResponseToJSONTyped(json, false);
}

export function AmsParametersResponseToJSONTyped(value?: AmsParametersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sid': value['sid'],
        'mappings': ((value['mappings'] as Array<any>).map(AmsVidMappingResponseToJSON)),
    };
}

